import {decode} from "html-entities";

type HtmlLinkPieceInfo = {
  type: "link";
  url: string;
  title: string;
};

type TextPieceInfo = {
  type: "text";
  text: string;
};

type PieceInfo = HtmlLinkPieceInfo | TextPieceInfo;

type RowInfo = PieceInfo[];

export const formatNewsDateLong = (date: string) => {
  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return parsedDate.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

export const formatNewsDateShort = (date: string) => {
  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return parsedDate.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const transformHtml = (text: string) => {
  let res = text
    ?.replace(/<style(.|\n)*?style>/g, "")
    .replace(/\[\/?siteorigin_widget(.|\n)*?\]/g, "")
    .replace(/<(.|\n)*?>/g, "")
    .replace(/\n *\n(\n| )*/g, "\n\n")
    .replace(/\n+$/, "");
  res = decode(res);
  return res;
};

const parseRow = (row: string): RowInfo => {
  const pieces: RowInfo = [];
  const linkRegex = /<a\s+[^>]*href="(?<url>https?:[^"]*)"[^>]*>(?<title>[\s\S]*?)<\/a>/gi;
  let lastIndex = 0;

  for (const match of row.matchAll(linkRegex)) {
    const index = match.index ?? 0;
    const beforeLink = row.slice(lastIndex, index);
    const cleanedBeforeLink = transformHtml(beforeLink);

    if (cleanedBeforeLink) {
      pieces.push({
        type: "text",
        text: cleanedBeforeLink,
      });
    }

    const url = match.groups?.url;
    const title = match.groups?.title;

    if (url) {
      const cleanedTitle = transformHtml(title ?? "");
      pieces.push({
        type: "link",
        url,
        title: cleanedTitle || url,
      });
    }

    lastIndex = index + match[0].length;
  }

  const afterLastLink = row.slice(lastIndex);
  const cleanedAfterLastLink = transformHtml(afterLastLink);

  if (cleanedAfterLastLink) {
    pieces.push({
      type: "text",
      text: cleanedAfterLastLink,
    });
  }

  return pieces;
};

export const separateLinksFromText = (text: string): RowInfo[] | undefined => {
  if (!text) return undefined;

  const rows = text
    .split(/\r?\n/)
    .map((row) => parseRow(row))
    .filter((row) => row.length > 0);

  return rows.length > 0 ? rows : undefined;
};
